/**
 * BasemapToggleButton (2026-05-03 UAT bug #2) — toggles between vector
 * cartography (OFM) and ESRI World Imagery raster basemap.
 *
 * Mirrors the [LabelToggleButton] visual + ARIA pattern: aria-pressed reflects
 * "satellite is currently on", aria-label is the destination action ("Switch
 * to Map view" when satellite is on; "Switch to Satellite view" when off) so
 * screen readers announce what TAPPING does, not what state is.
 *
 * Icon: Satellite (lucide). Symmetric — no RTL mirror.
 */
import { Satellite } from "lucide-react";
import { useIntl } from "react-intl";

interface BasemapToggleButtonProps {
  satellite: boolean;
  onToggle: () => void;
}

export function BasemapToggleButton({ satellite, onToggle }: BasemapToggleButtonProps) {
  const intl = useIntl();
  const ariaLabel = intl.formatMessage({
    id: satellite ? "LABEL_BASEMAP_CARTO" : "LABEL_BASEMAP_SATELLITE",
  });
  return (
    <button
      type="button"
      aria-pressed={satellite}
      aria-label={ariaLabel}
      onClick={onToggle}
      data-testid="basemap-toggle-button"
      className={`h-9 w-9 rounded-md focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 inline-flex items-center justify-center transition-colors duration-200 ${
        satellite
          ? "bg-secondary-container text-on-secondary-container"
          : "bg-surface-raised text-on-surface ring-1 ring-divider"
      }`}
    >
      <Satellite size={18} aria-hidden="true" />
    </button>
  );
}
